
    import { defineComponent, PropType } from 'vue'

    import { Category } from '@/common/models/data/dashboard/posts/category'

    export default defineComponent({
        props: {
            category: {
                type: Object as PropType<Category>,
                required: true
            }
        }
    })
